import { format } from "date-fns";
import type { Tables } from "../../database.types";
import type { ShopOrderWithPayment } from "./shop.service";

type ShopOrderLine = Tables<"shop_order_items">;

export type ShopOrderStatusTone = "pending" | "active" | "cancelled";

const SHOP_ORDER_STATUSES: Record<
  string,
  { label: string; tone: ShopOrderStatusTone }
> = {
  paid: { label: "PAGATO", tone: "pending" },
  delivered: { label: "CONSEGNATO", tone: "active" },
  cancelled: { label: "ANNULLATO", tone: "cancelled" },
};

export const getShopOrderStatus = (status: string) => {
  const knownStatus = SHOP_ORDER_STATUSES[status];

  if (knownStatus) {
    return knownStatus;
  }

  return { label: status.toUpperCase(), tone: "pending" as const };
};

export const getShopOrderLineTotalCents = (line: ShopOrderLine) => {
  return line.unit_price_cents * line.quantity;
};

const pluralize = (count: number, singular: string, plural: string) => {
  return `${count} ${count === 1 ? singular : plural}`;
};

/**
 * The one-line recap of an order card, e.g. "2 PRODOTTI · 3 PEZZI".
 */
export const getShopOrderContentsLabel = (order: ShopOrderWithPayment) => {
  const lines = order.shop_order_items;
  const pieces = lines.reduce((total, line) => {
    return total + line.quantity;
  }, 0);

  return [
    pluralize(lines.length, "PRODOTTO", "PRODOTTI"),
    pluralize(pieces, "PEZZO", "PEZZI"),
  ].join(" · ");
};

export const formatShopOrderDate = (date: string) => {
  return format(new Date(date), "dd/MM/yyyy");
};

export const formatShopOrderTime = (date: string) => {
  return format(new Date(date), "HH:mm");
};

/**
 * Orders have no human-readable number yet, so the list card and the detail
 * share this title to show which order is open.
 */
export const getShopOrderTitle = (order: ShopOrderWithPayment) => {
  return `ORDINE DEL ${formatShopOrderDate(order.created_at)}`;
};

export const formatShopOrderDateTime = (date: string) => {
  return format(new Date(date), "dd/MM/yyyy · HH:mm");
};
